import welcomeIllustration from '../../assets/images/onboarding/survey-welcome.jpg';
import mainGoalIllustration from '../../assets/images/onboarding/survey-main-goal.jpg';
import poundsToLoseIllustration from '../../assets/images/onboarding/survey-pounds-to-lose.webp';
import commitmentLevelIllustration from '../../assets/images/onboarding/survey-commitment-level.webp';
import buddyTypeIllustration from '../../assets/images/onboarding/survey-buddy-type.webp';
import communicationStyleIllustration from '../../assets/images/onboarding/survey-communication-style.webp';
import checkInFrequencyIllustration from '../../assets/images/onboarding/survey-check-in-frequency.webp';
import genderPreferenceIllustration from '../../assets/images/onboarding/survey-gender-preference.webp';
import ageRangeIllustration from '../../assets/images/onboarding/survey-age-range.webp';
import matchLoadingIllustration from '../../assets/images/onboarding/match-loading.webp';
import matchResultsIllustration from '../../assets/images/onboarding/match-results.webp';
import aiBuddyIllustration from '../../assets/images/onboarding/ai-buddy-found.webp';

/**
 * Artwork per survey step, keyed by the `/survey/:questionId` param (`welcome`
 * stands in for the intro screen at `/survey`). `q9` — the personalization
 * ratings — is intentionally absent: that step is a long scrolling list and the
 * design keeps it illustration-free.
 */
export const SURVEY_ILLUSTRATIONS: Record<string, string> = {
  welcome: welcomeIllustration,
  q1: mainGoalIllustration,
  q2: poundsToLoseIllustration,
  q3: commitmentLevelIllustration,
  q4: buddyTypeIllustration,
  q5: communicationStyleIllustration,
  q6: checkInFrequencyIllustration,
  q7: genderPreferenceIllustration,
  q8: ageRangeIllustration,
};

export const MATCH_ILLUSTRATIONS = {
  loading: matchLoadingIllustration,
  results: matchResultsIllustration,
  aiBuddy: aiBuddyIllustration,
} as const;
